import { getScribeById } from 'JS/sagas/selectors';
import { select, call, take } from 'redux-saga/effects';
import uniq from 'lodash.uniq';
import getScribeLengthMs from 'JS/playback/lib/Playback/helpers/getScribeLengthMs';
import { DUPLICATE_SCRIBE_FAILED, DUPLICATE_SCRIBE_SUCCESS } from 'JS/actionCreators/duplicateScribeActions';

import { incrementEventSuperProperty, incrementUserProperties, track } from '../mixpanelProvider';

const getAudioTypes = (clips = []) => {
  if (!clips.length) return;
  return uniq(clips.map(clip => clip.type));
};

export default function* trackDuplicateScribeSaga({ scribeId }) {
  const successOrFailAction = yield take([DUPLICATE_SCRIBE_SUCCESS, DUPLICATE_SCRIBE_FAILED]);

  if (successOrFailAction.type === DUPLICATE_SCRIBE_SUCCESS) {
    const sourceScribe = yield select(getScribeById, scribeId);
    const scribeLengthSeconds = getScribeLengthMs(sourceScribe) / 1000;

    const eventProperties = {
      'Scribe ID': scribeId,
      'Scribe Type': sourceScribe.source?.type || 'unknown',
      'Audio Type': getAudioTypes(sourceScribe.audioClips),
      'Scribe Length': scribeLengthSeconds,
      'Number of Elements': sourceScribe.elements.length || 0,
      'Number of Scenes': sourceScribe.scenes?.length || 0,
      ...(sourceScribe.source?.type === 'template' ? { 'Template Title': sourceScribe.source.meta?.title } : {})
    };

    yield call(track, 'Duplicate Scribe', eventProperties);

    yield call(incrementUserProperties, {
      'Total Scribes Created': 1,
      'Duplicate Scribes Created': 1
    });
    yield call(incrementEventSuperProperty, 'Total Scribes Created');
    yield call(incrementEventSuperProperty, 'Duplicate Scribes Created');
  }
}
